/* eslint-disable react/prop-types */
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import FileUpload from '@mui/icons-material/FileUpload'
import { FormControl, FormControlLabel, Radio, RadioGroup, Stack } from '@mui/material'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'

import ComboBox from 'Components/ComboBox'
import { find, isEmpty } from 'lodash'
import React, { useState } from 'react'
import { useForm } from 'react-hook-form'
import CustomButton from '../../../Components/CustomButton/CustomButton'
import { Input } from '../../../Components/Input'
import { makeGetRequest, makePostRequest } from '../../../utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// LAP-XXX — Social Dashboard v2 : champs Importance + Type de relation.
import RelationshipFields from '../_shared/RelationshipFields'

export default function ModifierCreateForm({ ID, fetchOperations }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const Titres = [
    { id: 1, label: 'Mme' },
    { id: 2, label: 'Mr' },
    { id: 3, label: 'Mlle' },
    { id: 4, label: 'Dr' },
    { id: 5, label: 'ST' },
  ]

  const [open, setOpen] = useState(false)
  const [openGroup, setOpenGroup] = useState(false)
  const [getUser, setUser] = useState(null)
  // LAP-XXX — Social Dashboard v2.
  const [rating, setRating] = useState(0)
  const [relationshipType, setRelationshipType] = useState(null)
  const [categories, setCategories] = useState([])
  const [Souscategories, setSousCategories] = useState([])
  const [selectedSousCategories, setSelectedSousCategories] = useState([])
  const [getPays, setPays] = useState([])
  const [file, setFile] = useState(null)
  const [getInformation, setInformation] = useState(false)
  const [getSocialMedia, setSocialMedia] = useState(false)
  const [getAddress, setAddress] = useState(false)
  const [DATA, setDATA] = useState({})
  const [Groupes, setGroupes] = useState([])
  const [sousCategory, setSousCategory] = useState('')
  const [editCat, setEditCat] = useState(false)
  const [editSouCat, setEditSouCat] = useState(false)
  const [editCountry, setEditCountry] = useState(false)

  React.useEffect(() => {
    if (!isEmpty(Souscategories)) {
      const selectedCat = find(Souscategories, ['category', sousCategory])
      setSelectedSousCategories([selectedCat])
    }
  }, [sousCategory])

  const Getuser = async () => {
    const user = await makeGetRequest(`/api/Social/get-contact/${ID}`, {}, true)
    if (user.status === 200) {
      if (user.data.length > 0) {
        let dd = user.data[0]
        setUser(dd)
        // LAP-XXX — préremplissage rating + relationship_type.
        setRating(dd.rating || 0)
        setRelationshipType(dd.relationship_type || null)
        return dd
      }
    }
    return {}
  }

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {},
  })

  const fetchPays = async () => {
    const url = '/api/Social/get-countries/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterPays = []
      data.forEach((v) => {
        filterPays.push({ label: `${v.CountryCode}`, id: v.id })
      })
      setPays([...filterPays])
    }
  }
  const fetchCategories = async () => {
    const url = '/api/Social/get-categories/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterCategories = []
      data.Categorie.forEach((v) => {
        filterCategories.push({ label: `${v.id}-${v.Categorie}`, id: v.id })
      })
      const filterSousCategories = []
      data.SousCategorie.forEach((v) => {
        filterSousCategories.push({
          label: `${v.id}-${v.SousCategorie}`,
          id: v.id,
          category: v.Categorie,
        })
      })
      setSousCategories([...new Set(filterSousCategories)])
      setCategories([...new Set(filterCategories)])
    }
  }
  const fetchGroupes = async () => {
    const url = '/api/Social/get-groups/'
    const { data, status } = await makeGetRequest(url, {}, true)
    if (status === 200) {
      const filterGroupes = []
      data.forEach((v) => {
        filterGroupes.push(v.Name)
      })
      setGroupes(filterGroupes)
    }
  }
  const handleClickOpen = async (e) => {
    fetchGroupes()
    let res_user = await Getuser()
    const data = {
      Titre: Titres[res_user?.Titre - 1],
      Nom: res_user?.Nom,
      Prenom: res_user?.Prenom,
      Anniversaire: res_user?.Anniversaire?.split('-').reverse().join('-'),
      Telephone: res_user?.Telephone,
      Email: res_user?.Email,
      Categorie: categories[res_user?.Category[0]?.id],
      f: `${Souscategories[res_user?.Category[0]?.id]?.label}`,
      Category: `${categories[res_user?.Category[0]?.id]?.label}`,
      Pays: `${getPays[res_user?.Pays[0]?.id]?.CountryCode}`,
      Job: res_user?.Job,
      Société: res_user?.Societe,
      'Téléphone pro': res_user?.Telephone,
      'Email pro': res_user?.EmailAlt,
      Instagram: res_user?.Instagram,
      Facebook: res_user?.Facebook,
      Linkedin: res_user?.Linkedin,
      WebPage: res_user?.WebPage,
      Ville: res_user?.Ville,
      Groupes: res_user?.Groupes[0]?.Name,
    }
    // setDATA(data)
    // reset(DATA)
    fetchCategories()
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    reset()
    setUser(null)
    setCategories([])
    setSousCategories([])
    setFile(null)
    setAddress(false)
    setSocialMedia(false)
    setSocialMedia(false)
    fetchOperations()
  }

  const onSubmit = (data) => {
    let url = '/api/Social/modify-contact/'
    let formData = new FormData()
    formData.append('ID', ID)

    formData.append('Titre', data.Titre?.id ? data.Titre?.id : getUser?.Titre)

    formData.append('Nom', data.Nom ? data.Nom : getUser.Nom)

    formData.append('Prenom', data.Prenom ? data.Prenom : getUser.Prenom)

    formData.append(
      'Anniversaire',
      data.Anniversaire ? data.Anniversaire : getUser?.Anniversaire.split('-').reverse().join('-'),
    )

    formData.append(
      'Portable',
      data.Portable || data.Portable === null ? getUser.Portable : data.Portable,
    )

    formData.append('Email', data.Email ? data.Email : getUser.Email)

    formData.append(
      'Categorie',
      getUser?.Categorie?.length !== undefined ||
        getUser?.Categorie?.length !== 0 ||
        getUser?.Categorie?.length !== null ||
        data.Categorie?.id
        ? data.Categorie?.id
        : getUser?.Categorie[0]?.id,
    )

    formData.append('Job', data.Job ? getUser?.Job : data.Job)

    formData.append('Société', data.Société ? getUser?.Societe : data.Société)

    formData.append(
      'Téléphone pro',
      data['Téléphone pro'] ? getUser?.Telephone : data['Téléphone pro'],
    )

    formData.append('Email pro', data['Email pro'] ? getUser?.EmailAlt : data['Email pro'])

    formData.append('Instagram', data.Instagram || getUser?.Instagram)

    formData.append('Facebook', data.Facebook || getUser?.Facebook)

    formData.append('Linkedin', data.Linkedin || getUser?.Linkedin)

    formData.append('WebPage', data.WebPage || getUser?.WebPage)
    console.log(getUser?.Pays)
    formData.append('Pays', data.Pays ? data.Pays.id : getUser?.Pays[0]?.id)

    formData.append('Ville', data.Ville ? data.Ville : getUser?.Ville)

    // LAP-XXX — Social Dashboard v2 : rating + relationship_type.
    formData.append('rating', String(rating ?? 0))
    if (relationshipType) {
      formData.append('relationship_type', relationshipType)
    }

    if (file !== null || file !== undefined) {
      formData.append('image', file)
    }
    formData.append('Groupes', data.Groupes ? getUser?.Groupes[0]?.Name : data.Groupes)

    let response = makePostRequest(
      url,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },

      true,
    )
      .then((res) => {
        fetchOperations()
      })
      .catch((err) => {
        console.log(err.response.data)
      })
    if (response.status === 201) {
      handleClose()
    }
    fetchOperations()
    setOpen(false)
  }

  return (
    <>
      {/* LAP-733 (GE022) */}
      <CustomButton onClick={handleClickOpen}>{t('contacts.btnEdit')}</CustomButton>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={handleClose}>
        {/* LAP-733 (GE022) */}
        <DialogTitle>{t('contacts.dlgEditContacts')}</DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <ComboBox
              handleAutoComplete={(e, j) => setValue('Titre', j)}
              label="Titre"
              data={Titres}
              name="Titre"
              isOptionEqualToValue={(option, value) => option.id === value.id}
              selectedValue={Titres[getUser?.Titre - 1]}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                size: 'small',
                type: 'text',

                defaultValue: getUser?.Nom === 'undefined' ? '' : getUser?.Nom,
              }}
              name="Nom"
              label="Nom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                defaultValue: getUser?.Prenom === 'undefined' ? '' : getUser?.Prenom,
              }}
              name="Prenom"
              label="Prénom"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'Date',
                required: true,
                defaultValue: getUser?.Anniversaire?.split('-').reverse().join('-'),
              }}
              name="Anniversaire"
              // label='Anniversaire'
              sx={{ width: '98%' }}
              InputLabelProps={{ shrink: true }}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                defaultValue: getUser?.Portable === 'undefined' ? '' : getUser?.Portable,
              }}
              name="Portable"
              label="Portable"
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
                defaultValue: getUser?.Email === 'undefined' ? '' : getUser?.Email,
              }}
              name="Email"
              label="Email"
            />
            {/* LAP-XXX — Social Dashboard v2 : importance + type de relation. */}
            <RelationshipFields
              rating={rating}
              relationshipType={relationshipType}
              onChangeRating={setRating}
              onChangeRelationshipType={setRelationshipType}
            />
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              readOnly
              name="Category"
              label={'Categorie (legacy)'}
              value={`${getUser?.Category[0]?.Categorie}`}
            />
            <div
              onClick={() => setEditCat(!editCat)}
              style={{ color: 'blue', backgroundColor: 'none' }}
              className="link pointer float-right"
            >
              Edit Categorie
            </div>
            {editCat && (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('Categorie', j)}
                label="Categorie"
                data={categories}
                name="Categorie"
                onClose={(event) => {
                  setSousCategory(event.target.innerHTML.split('-')[1])
                }}
                // selectedValue={categories[getUser?.Category[0]?.id]}
              />
            )}
            <Input
              control={control}
              inputProps={{
                variant: 'outlined',
                type: 'text',
              }}
              readOnly
              name="f"
              label={'SousCategorie'}
              value={`${getUser?.Category[0]?.SousCategorie}`}
            />
            <div
              onClick={() => setEditSouCat(!editSouCat)}
              style={{ color: 'blue', backgroundColor: 'none' }}
              className="link pointer float-right"
            >
              Edit SousCategorie
            </div>
            {editSouCat && (
              <ComboBox
                handleAutoComplete={(e, j) => setValue('SousCategorie', j)}
                label="SousCategorie"
                data={selectedSousCategories}
                name="SousCategorie"
                // selectedValue={Souscategories[getUser?.Category[0]?.id]}
              />
            )}

            <Stack mt={2} justifyContent="center" width={'100%'}>
              <Button variant="outlined" component="label">
                <FileUpload /> Charger photo
                <input type="file" hidden onChange={(e) => setFile(e.target.files[0])} />
              </Button>
            </Stack>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setOpenGroup(true)}>
                  Affectation groupe <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={openGroup}
                  onClose={() => setOpenGroup(false)}
                >
                  <DialogTitle>Groupe</DialogTitle>
                  <form>
                    <DialogContent>
                      <FormControl>
                        <RadioGroup
                          onChange={(e) => {
                            setValue('Groupes', e.target.value)
                          }}
                          aria-labelledby="Groupes"
                          name="Groupes"
                          defaultValue={getUser?.Groupes[0]?.Name}
                        >
                          {Groupes.map((v) => {
                            return (
                              <FormControlLabel
                                key={v.index}
                                value={v}
                                control={<Radio />}
                                label={v}
                              />
                            )
                          })}
                        </RadioGroup>
                      </FormControl>
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setOpenGroup(false)}>Valider</Button>
                      <Button onClick={() => setOpenGroup(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setInformation(true)}>
                  Informations professionnelles <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getInformation}
                  onClose={() => setInformation(false)}
                >
                  <DialogTitle>Informations pro</DialogTitle>
                  <form>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                          defaultValue: getUser?.Job,
                        }}
                        name="Job"
                        label="Job"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                          defaultValue: getUser?.Societe,
                        }}
                        name="Société"
                        label="Société"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                          defaultValue: getUser?.Telephone,
                        }}
                        name="Téléphone pro"
                        label="Téléphone pro"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          defaultValue: getUser?.EmailAlt,
                        }}
                        name="Email pro"
                        label="Email pro"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setInformation(false)}>Valider</Button>
                      <Button onClick={() => setInformation(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton sx={{ color: '#1d78d2' }} onClick={() => setSocialMedia(true)}>
                  Réseaux sociaux <ArrowForwardIcon />
                </CustomButton>
                <Dialog
                  fullWidth
                  maxWidth="xs"
                  open={getSocialMedia}
                  onClose={() => setSocialMedia(false)}
                >
                  <DialogTitle>Réseaux</DialogTitle>
                  <form>
                    <DialogContent>
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                          defaultValue: getUser?.Instagram,
                        }}
                        name="Instagram"
                        label="Instagram"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          size: 'small',
                          defaultValue: getUser?.Facebook,
                        }}
                        name="Facebook"
                        label="Facebook"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          size: 'small',
                          type: 'text',
                          defaultValue: getUser?.Linkedin,
                        }}
                        name="Linkedin"
                        label="LinkedIn"
                      />
                      <Input
                        control={control}
                        inputProps={{
                          variant: 'outlined',
                          type: 'text',
                          defaultValue: getUser?.WebPage,
                        }}
                        name="WebPage"
                        label="Web Page"
                      />
                    </DialogContent>
                    <DialogActions>
                      <Button onClick={() => setSocialMedia(false)}>Valider</Button>
                      <Button onClick={() => setSocialMedia(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
              <>
                <CustomButton
                  sx={{ color: '#1d78d2' }}
                  onClick={() => {
                    setAddress(true)
                    fetchPays()
                  }}
                >
                  Adresse <ArrowForwardIcon />
                </CustomButton>
                <Dialog fullWidth maxWidth="xs" open={getAddress} onClose={() => setAddress(false)}>
                  <DialogTitle>Adresse</DialogTitle>
                  <form>
                    <Input
                      control={control}
                      inputProps={{
                        variant: 'outlined',
                        type: 'text',
                      }}
                      readOnly
                      name="Pays"
                      label={'Pays'}
                      value={`${getUser?.Pays[0]?.CountryCode} - ${getUser?.Pays[0]?.Designation}`}
                    />
                    <div
                      onClick={() => setEditCountry(!editCountry)}
                      style={{ color: 'blue', backgroundColor: 'none' }}
                      className="link pointer float-right"
                    >
                      Edit Pays
                    </div>
                    {editCountry && (
                      <DialogContent>
                        <ComboBox
                          handleAutoComplete={(e, j) => setValue('Pays', j)}
                          label="Pays"
                          data={getPays}
                          name="Pays"
                          selectedValue={getUser?.Pays[0]?.id}
                        />
                        <Input
                          control={control}
                          inputProps={{
                            variant: 'outlined',
                            type: 'text',
                            size: 'small',
                            defaultValue: getUser?.Ville === 'undefined' ? '' : getUser?.Ville,
                          }}
                          name="Ville"
                          label="Ville"
                        />
                      </DialogContent>
                    )}

                    <DialogActions>
                      <Button onClick={() => setAddress(false)}>Valider</Button>
                      <Button onClick={() => setAddress(false)}>Annuler</Button>
                    </DialogActions>
                  </form>
                </Dialog>
              </>
            </div>
          </DialogContent>
          <DialogActions>
            <Button type="submit">Valider</Button>
            <Button onClick={handleClose}>Annuler</Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
